var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('basic-card',[_c('data-table',{attrs:{"data":_vm.currencies,"configuration":_vm.currencyTableConfig,"component-id":"currencies-list"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }